<h2 mat-dialog-title>Submit Feedback</h2>
<form [formGroup]="feedbackForm">
  <mat-dialog-content>
    <mat-form-field class="d-block mb-3">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type">
        <mat-option value="Error">Error</mat-option>
        <mat-option value="Feedback">Feedback</mat-option>
        <mat-option value="FeatureRequest">Feature Request</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="d-block mb-3">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" required>
      <mat-error>Title is required</mat-error>
    </mat-form-field>

    <quill-editor
      formControlName="description"
      [modules]="quillModules"
      [format]="'html'"
      [style]="{ height: '200px', width: '100%' }">
    </quill-editor>

    @if (feedbackForm.get('type')?.value === 'Error') {
      <mat-checkbox formControlName="notifyTeam" class="d-block mt-3">
        Notify my team members of this error submission
      </mat-checkbox>
    }

    @if (feedbackForm.get('type')?.value === 'Error' && feedbackForm.get('notifyTeam')?.value) {
      <p class="mat-body-2 text-muted mt-3 mb-0">You and your team will automatically be CC'd on this email.</p>
    } @else {
      <p class="mat-body-2 text-muted mt-3 mb-0">You will automatically be CC'd on this email.</p>
    }

    @if (isSubmitting()) {
      <div class="overlay">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close [disabled]="isSubmitting()">Cancel</button>
    <button mat-button
      [disabled]="!feedbackForm.valid || isSubmitting()"
      (click)="onSubmit()">
      @if (isSubmitting()) { Submitting... } @else { Submit }
    </button>
  </mat-dialog-actions>
</form>
